import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import SiteHome from "@/ComponentsRoot/SiteHome.vue";
import ParticipantRegistration from "@/ComponentsRoot/ParticipantRegistration.vue";
import ParticipantApplication from "@/ComponentsRoot/ParticipantApplication.vue";
import ParticipantLogin from "@/ComponentsRoot/ParticipantLogin.vue";
import ApplicationStatus from "@/ComponentsRoot/ApplicationStatus.vue";
import ApplicationSubmitted from "@/ComponentsRoot/ApplicationSubmitted.vue";
import CallbackPage from "@/ComponentsRoot/CallbackPage.vue";
import { useAuth0 } from '@/Services/Auth0/auth0-plugin';
import { Auth0 } from '@/Services/Auth0/auth0-interface';

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: SiteHome,
        meta: {
            title: 'WDH Waivers Participant Portal - Home',
        },
    },
    {
        path: "/register",
        name: "register",
        component: ParticipantRegistration,
        meta: {
            title: 'WDH Waivers Participant Portal - Register',
        },
    },
    {
        path: "/application",
        name: "application",
        component: ParticipantApplication,
        meta: {
            title: 'WDH Waivers Participant Portal - Application',
        },
    },
    {
        path: "/login",
        name: "login",
        component: ParticipantLogin,
        meta: {
            title: 'WDH Waivers Participant Portal - Login',
        },
    },
    {
        path: "/submitted",
        name: "submitted",
        component: ApplicationSubmitted,
        meta: {
            title: 'WDH Waivers Participant Portal - Submitted',
        },
    },
    {
        path: "/application-status",
        name: "application-status",
        component: ApplicationStatus,
        meta: {
            title: 'WDH Waivers Participant Portal - Application Status',
        },
    },
    {
        path: "/callback",
        name: "callback",
        component: CallbackPage,
        meta: {
            title: 'WDH Waivers Participant Portal',
        },
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(async (to, from, next) => {
    // Update the title based on the route's meta information
    document.title = (to.meta.title as string) || 'Default Title';

    const auth0: Auth0 | null = useAuth0(); // Initialize useAuth0 inside the hook

    // Early exit if auth0 is not initialized
    if (!auth0) {
        next(); // Allow the navigation to proceed
        return;
    }

    try {
        const token = await auth0.getAccessToken(); // Fetch the token only when required

        // If no token and trying to access a protected route (adjust as needed)
        const isPublicRoute = ['/login', '/register', '/callback'].includes(to.path);

        if (!token && !isPublicRoute) {
            if (to.path !== '/') {
                next({ path: '/' }); // Redirect to home only if not already there
            } else {
                next(); // Stay on home if already there
            }
        } else {
            next(); // Allow navigation if token exists or route is public
        }
    } catch (error) {
        console.error("Error fetching access token:", error);
        if (to.path !== '/') {
            next({ path: '/' }); // Redirect to home if error occurs and not already on home
        } else {
            next(); // Stay on home if already there
        }
    }
});

export default router;
